import { addDelegateEventListener, openDialog } from "@remarkablenet/utils";
import "../../css/pages/homepage.scss";
import "../../css/pages/cms-page.scss";
import componentCarousel from "../modules/component-carousel/component-carousel";
import SetupReadmore from "../modules/readmore/readmore";

function init() {
	console.log("You are on the homepage");
	componentCarousel();
	SetupReadmore();

	customCMSTriggers();
}

const customCMSTriggers = () => {
	addDelegateEventListener(document, "click", ".js-register-trigger", function (e) {
		console.log("Register Trigger Clicked");
		e.originalEvent.preventDefault();
		const target = e.originalEvent.target as HTMLAnchorElement;
		const updateTarget = async () => {
			target.setAttribute("data-dialog-class", "max-w-full max-h-full w-full h-full md:w-11/12 md:h-5/6 md:max-w-5xl");
		}
		updateTarget().then(() => {
			openDialog(target);
		});
	});

	addDelegateEventListener(document, "click", ".js-login-trigger", function (e) {
		console.log("Login Trigger Clicked");
		e.originalEvent.preventDefault();
		const target = e.originalEvent.target as HTMLAnchorElement;
		const updateTarget = async () => {
			target.setAttribute("data-dialog-class", "max-w-full max-h-full overflow-hidden rcm-dialog__right");
		}
		updateTarget().then(() => {
			openDialog(target);
		});
	});
};

const exit = () => {
	console.log("Homepage: Exit");
};

window.homepage = {
	init,
	exit,
};
